import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
const ROWS: {
  without: string;
  with: string;
}[] = [{
  without: 'Improvised practices',
  with: 'Practices planned in detail'
}, {
  without: 'Not sure what to teach first',
  with: 'Clear step-by-step progression'
}, {
  without: 'Bored players',
  with: 'Practices that keep them engaged'
}, {
  without: 'No team data',
  with: 'Ready-to-use scouting and stats'
}, {
  without: 'Pressure from parents',
  with: 'Communication under control'
}, {
  without: 'Coaching only how you played',
  with: 'A proven system behind you'
}];
export function ComparisonTable() {
  return <div className="overflow-hidden rounded-2xl border border-orange-500/30 bg-neutral-900/80 backdrop-blur-sm" data-id="element-88">
      <div className="grid grid-cols-2" data-id="element-89">
        {/* Header */}
        <div className="border-b border-r border-neutral-700 bg-neutral-800/70 px-2 py-3 text-center" data-id="element-90">
          <p className="text-[11px] font-bold uppercase leading-tight text-neutral-400" data-id="element-91">
            Without Basketball Resolved
          </p>
        </div>
        <div className="border-b border-orange-500/40 bg-orange-500/15 px-2 py-3 text-center" data-id="element-92">
          <p className="text-[11px] font-bold uppercase leading-tight text-orange-400" data-id="element-93">
            With Basketball Resolved
          </p>
        </div>

        {/* Rows */}
        {ROWS.map((row, i) => <div key={i} className="contents" data-id="element-94">
            <div className="flex items-start gap-1.5 border-b border-r border-neutral-800 px-2 py-2.5" data-id="element-95">
              <XIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-red-500" data-id="element-96" />
              <span className="text-[11px] leading-tight text-neutral-400" data-id="element-97">
                {row.without}
              </span>
            </div>
            <div className="flex items-start gap-1.5 border-b border-neutral-800 bg-orange-500/5 px-2 py-2.5" data-id="element-98">
              <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-orange-400" data-id="element-99" />
              <span className="text-[11px] font-medium leading-tight text-white" data-id="element-100">
                {row.with}
              </span>
            </div>
          </div>)}
      </div>
    </div>;
}